import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ApiBasket, createBasket } from 'src/api/basketService';
import { syncBasket } from 'src/utils/sync-basket';
import { CreateBasketDto } from 'src/api/basketService/dto/CreateBasket.dto';

import { queryRetry } from '../query-retry';

export const useCreateBasket = () =>
    useMutation<ApiBasket, AxiosError, CreateBasketDto>({
        mutationKey: ['createBasket'],
        mutationFn: (basketData) => createBasket(basketData),
        retry: queryRetry,
        onSuccess: (basket) => {
            syncBasket(basket);
        },
        onError() {},
    });
